import _get from "lodash/get";
import { isAuthenticateAction } from "../../utils/auth";
import { readVisitorProductShoppingActions, requestIdentity } from "../../actions"; // clear visitor data when we think the user is signed in

var shouldClearData = function shouldClearData(action) {
  return isAuthenticateAction(action) || action.type === requestIdentity.SUCCESS_TYPE;
};

export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      payload = action.payload;
  if (shouldClearData(action)) return {};

  switch (type) {
    case readVisitorProductShoppingActions.SUCCESS_TYPE:
      return _get(payload, 'items');

    default:
      return state;
  }
});